import { ModalCustom } from "components/ModalCustom";
import { BodyEmissaoManual } from "./containers/BodyEmissaoManual";
import { ContainerForm } from "./style";
import { IEmissaoManual } from "../../interfaces/IEmissaoManual";

interface Props {
  showModal: boolean;
  handleClose: () => void;
  handleSubmit: (dados: IEmissaoManual) => void;
  ano: number;
}

export function ModalEmissaoManual({
  handleClose,
  showModal,
  handleSubmit,
  ano,
}: Readonly<Props>) {
  return (
    <ModalCustom
      show={showModal}
      handleClose={handleClose}
      title="Informar emissão manual"
      disabledConfirmButton
      centered
      size="lg"
    >
      <ContainerForm>
        <BodyEmissaoManual
          ano={ano}
          handleSubmitEmissaoManual={handleSubmit}
          handleClose={handleClose}
          dataEmissao={new Date()}
        ></BodyEmissaoManual>
      </ContainerForm>
    </ModalCustom>
  );
}

